var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-avatar',{attrs:{"color":_vm.color,"size":_vm.size}},[_c('span',{staticClass:"white--text"},[_vm._v(_vm._s(_vm.storeInitials))])])
}
var staticRenderFns = []

export { render, staticRenderFns }